import { render, staticRenderFns } from "./InventoryBaseTable.vue?vue&type=template&id=321d07fe&"
import script from "./InventoryBaseTable.vue?vue&type=script&lang=js&"
export * from "./InventoryBaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports